import React from "react";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import { Envelope, Lock } from "react-bootstrap-icons";
import loginBg from "../images/register-bg.png";
import { Loginlogic } from "../utils/Loginlogic";

import logo from "../images/cvv-nvbar.png";
import meityLogo from "../images/meitylogo.png";
import amritaLogo from "../images/amritalogo.png";
import cdacLogo from "../images/cdac.png";

function Login() {
    const {
        formData,
        handleChange,
        handleForgotPassword,
        handleSubmit,
        navigate,
        emailRef,
        isSubmitting,
    } = Loginlogic();

    return (
        <div className="login-page">
            {/* HEADER */}
            <header className="login-header">
                <Container fluid>
                    <div className="header-wrapper">
                        <div
                            className="main-logo cursor-pointer"
                            role="link"
                            tabIndex={0}
                            aria-label="Go to ChalaChithra Vaachana home page"
                            onClick={() => navigate("/")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") navigate("/");
                            }}
                        >
                            <img src={logo} alt="CCV Logo" />
                        </div>

                        <div className="partner-logos">
                            <img src={meityLogo} alt="MeitY" />
                            <img src={cdacLogo} alt="CDAC" />
                            <img src={amritaLogo} alt="Amrita" />
                        </div>
                    </div>
                </Container>
            </header>

            {/* MAIN */}
            <main
                className="login-main"
                style={{
                    backgroundImage: `url(${loginBg})`,
                }}
            >
                <Container>
                    <Row className="justify-content-center justify-content-md-start">
                        <Col xs={11} sm={9} md={6} lg={5} xl={4} className="login-box">
                            <h1 className="login-title">Login</h1>

                            <Form onSubmit={handleSubmit} aria-label="Login form">
                                {/* EMAIL */}
                                <Form.Group className="mb-3">
                                    <InputGroup className="custom-input-group">
                                        <InputGroup.Text className="input-icon">
                                            <Envelope />
                                        </InputGroup.Text>

                                        <Form.Control
                                            type="email"
                                            name="email"
                                            placeholder="Email"
                                            aria-label="Email address"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            ref={emailRef}
                                            className="custom-input"
                                            autoComplete="email"
                                        />
                                    </InputGroup>
                                </Form.Group>

                                {/* PASSWORD */}
                                <Form.Group className="mb-3">
                                    <InputGroup className="custom-input-group">
                                        <InputGroup.Text className="input-icon">
                                            <Lock />
                                        </InputGroup.Text>

                                        <Form.Control
                                            type="password"
                                            name="password"
                                            placeholder="Password"
                                            aria-label="Password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            required
                                            className="custom-input"
                                            autoComplete="current-password"
                                        />
                                    </InputGroup>
                                </Form.Group>

                                {/* FORGOT PASSWORD */}
                                <div className="forgot-wrapper">
                                    <button
                                        type="button"
                                        className="forgot-btn"
                                        onClick={handleForgotPassword}
                                        onKeyDown={(e) => e.key === "Enter" && handleForgotPassword()}
                                    >
                                        Forgot Password?
                                    </button>
                                </div>

                                {/* LOGIN BUTTON */}
                                <Button type="submit" className="login-btn" disabled={isSubmitting}>
                                    {isSubmitting ? "Logging in..." : "Login"}
                                </Button>

                                {/* SIGNUP - keep hidden if registration is not open */}
                                {/* <div className="signup-wrapper">
                  <span className="signup-text">Not a member?</span>

                  <button
                    type="button"
                    className="signup-btn"
                    onClick={() => navigate("/register")}
                  >
                    Sign Up
                  </button>
                </div> */}
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </main>

            {/* FOOTER */}
            <footer className="login-footer">
                <Container>
                    <div className="footer-text">
                        © {new Date().getFullYear()} Amrita CREATE | AI Video Accessibility Platform
                    </div>
                </Container>
            </footer>

            {/* CSS */}
            <style>{`
        .login-page {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
        }

        .login-header {
          background: #ffffff;
          padding: 10px 20px;
          border-bottom: 1px solid #e5e5e5;
          flex-shrink: 0;
        }

        .header-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 10px;
        }

        .main-logo img {
          height: 55px;
          width: auto;
          cursor: pointer !important;
        }

        .partner-logos {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .partner-logos img {
          height: 50px;
          width: auto;
        }

        .login-main {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          background-size: cover;
          background-position: center;
          padding: 20px;
        }

        .login-box {
          background: #b0004e;
          padding: 38px 34px;
          border-radius: 6px;
          max-width: 430px;
          width: 100%;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        }

        .login-title {
          color: #fff;
          text-align: center;
          font-size: 3rem;
          font-weight: 300;
          margin-bottom: 30px;
          letter-spacing: 0.5px;
        }

        .custom-input-group {
          overflow: hidden;
          border-radius: 4px;
        }

        .input-icon {
          background: #ffffff;
          border: none;
          color: #444;
          padding-left: 14px;
          padding-right: 14px;
        }

        .custom-input {
          border: none !important;
          box-shadow: none !important;
          height: 40px;
          font-size: 0.95rem;
          font-weight: 500;
          background: #dfe3ec;
        }

        .custom-input::placeholder {
          color: #666;
          font-size: 0.92rem;
        }

        .forgot-wrapper {
          text-align: right;
          margin-bottom: 22px;
        }

        .forgot-btn {
          background: transparent;
          border: none;
          color: #fff;
          font-size: 0.95rem;
          font-weight: 400;
          cursor: pointer;
          transition: 0.2s;
        }

        .forgot-btn:hover {
          opacity: 0.85;
        }

        .login-btn {
          width: 100%;
          background: #1f2733 !important;
          border: none !important;
          height: 44px;
          border-radius: 4px;
          font-size: 1.1rem;
          font-weight: 500;
          margin-bottom: 22px;
          transition: 0.3s;
        }

        .login-btn:hover {
          background: #111827 !important;
        }

        .login-btn:disabled {
          opacity: 0.75;
          cursor: not-allowed;
        }

        .signup-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }

        .signup-text {
          color: #fff;
          font-size: 1rem;
          font-weight: 400;
        }

        .signup-btn {
          border: 1px solid #fff;
          background: transparent;
          color: #fff;
          padding: 5px 18px;
          border-radius: 20px;
          font-size: 0.95rem;
          font-weight: 600;
          transition: 0.3s;
        }

        .signup-btn:hover {
          background: #fff;
          color: #b0004e;
        }

        .login-footer {
          background: #ffffff;
          border-top: 1px solid #e5e5e5;
          padding: 12px 10px;
          flex-shrink: 0;
        }

        .footer-text {
          text-align: center;
          color: #4b5563;
          font-size: 14px;
          font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
        }

        @media (max-width: 768px) {
          .login-box {
            padding: 32px 24px;
            margin: 10px auto;
          }

          .login-title {
            font-size: 2.5rem;
          }

          .partner-logos {
            width: 100%;
            justify-content: center;
          }

          .main-logo {
            width: 100%;
            text-align: center;
            cursor: pointer !important;
          }
        }

        @media (max-width: 480px) {
          .login-box {
            padding: 28px 20px;
          }

          .login-title {
            font-size: 2.2rem;
          }

          .signup-wrapper {
            flex-direction: row;
            flex-wrap: wrap;
          }

          .partner-logos img {
            height: 32px;
          }

          .main-logo img {
            height: 40px;
            cursor: pointer !important;
          }

          .footer-text {
            font-size: 0.82rem;
          }
        }
      `}</style>
        </div>
    );
}

export default Login;